import { Button, Form } from 'antd';
import { UpdateUserDTO  } from 'features/users/api/user-api.service';
import {UserFormField,UserFormValues} from 'features/users/components/users-filter-form';    
import {useUpdateUser } from 'features/users/use-cases';
import { useEffect, useState } from 'react';

import { PasswordFormItems } from './password-form-items';

export const ChangePasswordModal = ({ onClose, updateUserId }: { onClose: () => void, updateUserId: any }) => {
    const formName = 'change-user-password-form';
    const [validateTrigger, setValidateTrigger] = useState(['onSubmit']);
    const [form] = Form.useForm<UserFormValues>();
    const handleCloseCPM = () => {
        onClose();
        form.resetFields();
    }
    useEffect(() => {          
       form.resetFields();
    }, [updateUserId, form]);
    const getInitialValues = {
        [UserFormField.Password]: undefined
    };
    const {isLoading, mutate: mutateUpdateUser } = useUpdateUser();
    const handleChangePassword = (formData: any) => {
        formData.userId = updateUserId;       
        const payload: UpdateUserDTO = { ...formData};            
        mutateUpdateUser(payload, { onSuccess });
    };
    const onSuccess = () => {
        handleCloseCPM();
    };

    return (
        <>

            <div className={'popup'}>
                <div className='modal_head'>
                    <button onClick={handleCloseCPM} className='close-btn'>
                        &times;
                    </button>
                    <h4>Change Password</h4>
                </div>
                <div className='modal_body'>
                    <Form<UserFormValues>
                        id={formName}
                        name={formName}
                        form={form}
                        layout='vertical'
                        initialValues={getInitialValues}
                        
                        onFinish={handleChangePassword}                      
                        onFinishFailed={() => {
                            setValidateTrigger(['onChange']);
                        }}
                        validateTrigger={validateTrigger}
                        disabled={isLoading}
                    >
                       
                        <PasswordFormItems />

                        <div className='form-button'>
                            <Button type="primary" htmlType='submit' className="btn" >Change Password</Button>
                        </div>
                    </Form>
                </div>
            </div>

        </>
    );
};

